import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import * as PresenzeAction from '../../../../../store/actions/PresenzeAction'
import { connect } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import { createMuiTheme } from '@material-ui/core'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import * as DateTool from '../../../../../util/DateTool';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Searcher from '../../../../common/Searcher'

import Checkbox from '@mui/material/Checkbox';
import * as NumberTool from '../../../../../util/NumberTool'
import { modelProps as modelPropsDipendenti } from '../../../../../model/Dipendenti';
import { modelProps as modelPropsCantieri } from '../../../../../model/Cantieri';

import { checkInputRequired } from '../../../../../model/Presenze';

import DateFnsUtils from "@date-io/date-fns";
import itLocale from "date-fns/locale/it";


import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';

const styles = theme => ({

    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    table: {
        // minWidth: 650,
    },
    tableHead: {
        background: "#b9b9b9"
    },

    row: {
        '&:hover': {
            background: "#CACACA"
        }
    },
    cell: {
        '&:hover': {
            background: "#b9b9b9"
        },
    },
    modal: {
        display: 'block',
        position: 'absolute',
        overflow: 'scroll',
    },
    modalpaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: 900,
    },
    buttonback: {
        backgroundColor: "#b9b9b9",
        border: '0px solid #000',
        boxShadow: theme.shadows[0],
        padding: theme.spacing(1.5, 1.5, 1.5),

    },
    formControlS: {
        margin: theme.spacing(1),
        width: 120,
    },
    formControlM: {
        margin: theme.spacing(1),
        width: 300
    },
    formControlL: {
        margin: theme.spacing(1),
        width: 800
    },
    grammar: {
        width: 800
    },
    grammarPreview: {
        width: 800
    },
    cell_short: {
        fontSize: "10px",
        width: 50,
    },
    cell_medium: {
        fontSize: "10px",
        width: 100,
    },
    cell_clickable: {
        cursor: "pointer"
    },
    cell_searched: {
        background: "#FA8072"
    },
    gridItem: {
    },
    button: {
        background: 'white',
        borderRadius: 3,
        border: 0,
        color: 'black',
        padding: '0 20px',
        '&:hover': {
            background: "#b9b9b9"
        },
    },
    container: {
        maxHeight: 600,
    },
});

const customTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#bfbfbf',
            light: '#969696',
            dark: '#616060',
        },
        secondary: {
            main: '#616060',
        },
    },
})




var defaultFormValue = {

    "Data": null,
    "Presenza": null,
    "Ore": 0,
    "CostoOrario": 0,
    "LastModifiedBy": null,
    "LastModifiedAt": null,
    "Dipendenti": null,
    "Cantieri": null
};

class SimpleCrudModalCreate extends Component {

    constructor(props) {

        super();
        this.state = {
            formValue: Object.create(defaultFormValue),
            unfilledRequiredFIeld: true,
            openCreateModal: false,

        };


    }

    componentDidMount() {



    }


    handlCreateModalOpen = () => {
        this.setState({
            openCreateModal: true,
            formValue: Object.create(defaultFormValue),
            unfilledRequiredFIeld: true
        })

        //初期値
        this.handleDateTimeChange(new Date(), 'Data')
        this.onChangeInputCommon('Presenza', 'p')
        this.onChangeInputNumCommon('Ore', '')
        this.onChangeInputNumCommon('CostoOrario', '')
        this.onChangeInputCommon('LastModifiedBy', null)
        this.onChangeInputCommon('LastModifiedAt', null)
        if (this.props.role == 'euroalbek') {
            this.onChangeInputCommon('Dipendenti', null)
        }
        if (this.props.role == 'member') {
            this.onChangeInputCommon('Dipendenti', {}) //初期値（memberの場合dipendenti情報がnullだと入力必須チェックにひっかかる）
        }
        this.onChangeInputCommon('Cantieri', null)
        this.onChangeInputCommon('Descrizione', '')
        this.onChangeInputCommon('Confermata', true)

    };



    handleModalClose = () => {
        this.setState({ openCreateModal: false })
    };



    onChangeInputCommon = (key, value) => {


        var newFormValue = this.state.formValue;
        newFormValue[key] = value;
        this.setState({ formValue: newFormValue });

        console.log('newFormValue', newFormValue)



        this.checkInputRequired()

    }

    onChangeInputNumCommon = (key, value) => {
        this.setState({ formValue: NumberTool.validateAndSetNewFormValue(key, value, this.state.formValue) });
    }


    handleDateTimeChange = (datetime, key) => {

        var newFormValue = this.state.formValue;

        if (datetime == null || datetime == "") {
            newFormValue[key] = null;
        } else {
            newFormValue[key] = DateTool.createJSONDateWithoutTime(datetime);
        }
        this.setState({ formValue: newFormValue });

        this.checkInputRequired()

    }

    checkInputRequired = () => {
        this.setState({ unfilledRequiredFIeld: checkInputRequired(this.state.formValue) });
    }

    render() {

        var keys = Object.keys(this.props.modelProps);

        const { classes } = this.props;

        const nums = [];
        for (let i = 1; i <= 50; i++) {
            nums.push(i);
        }

        return (
            <div>
                <List>
                    <ListItem button key="Lessons" onClick={(e) => { e.preventDefault(); this.handlCreateModalOpen() }}>
                        <ListItemIcon>
                            <AddIcon />
                        </ListItemIcon>
                        <ListItemText primary="Aggiunta" />
                    </ListItem>
                </List>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={this.state.openCreateModal}
                    onClose={this.handleModalClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.state.openCreateModal}>
                        <div className={classes.modalpaper}>

                            <Grid container >
                                <Grid item xs={12}  >
                                    <h4 id="transition-modal-title">{this.props.modelName}</h4>
                                </Grid>
                                <Grid item xs={5}  >
                                    {this.props.role == 'euroalbek' &&
                                        <Grid item xs={12}  >
                                            <Searcher
                                                modelProps={modelPropsDipendenti}
                                                onSelect={(dipendenti) => {

                                                    this.onChangeInputCommon('Dipendenti', dipendenti)
                                                    //cost orario をマスタから保管
                                                    this.onChangeInputCommon('CostoOrario', dipendenti == null ? '' : dipendenti.CostoOrario == null ? '' : dipendenti.CostoOrario)

                                                }}
                                                showpropArr={['Nome', 'Cognome']} />
                                        </Grid>
                                    }
                                    <Grid item xs={12}  >
                                        <Searcher
                                            modelProps={modelPropsCantieri}
                                            onSelect={(cantieri) => {

                                                this.onChangeInputCommon('Cantieri', cantieri)

                                            }}
                                            showpropArr={['Descrizione']} />
                                    </Grid>
                                </Grid>
                                <Grid item xs={7}  >
                                    <form className={classes.root} noValidate autoComplete="on">
                                        <Grid container justify="left"  >
                                            {this.props.role == 'euroalbek' &&
                                                <Grid item xs={12} key={'form_Dipendenti'}  >
                                                    <FormControl className={classes.formControlM}>
                                                        <FormLabel component="legend">Dipendenti*</FormLabel>
                                                        <h4> {this.state.formValue.Dipendenti && this.state.formValue.Dipendenti.Nome + ' ' + this.state.formValue.Dipendenti.Cognome}</h4>

                                                    </FormControl>
                                                </Grid>
                                            }
                                            <Grid item xs={12} key={'form_Cantieri'}  >
                                                <FormControl className={classes.formControlM}>
                                                    <FormLabel component="legend">Cantieri</FormLabel>
                                                    <h4> {this.state.formValue.Cantieri && this.state.formValue.Cantieri.Descrizione}</h4>

                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} key={'form_Data'}  >
                                                <FormControl className={classes.formControlM}>
                                                    <MuiThemeProvider theme={customTheme}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={itLocale}>
                                                            <KeyboardDatePicker
                                                                margin="normal"
                                                                id="date-picker-dialog"
                                                                label='Data*'
                                                                format="dd/MM/yyyy"
                                                                value={this.state.formValue['Data']}
                                                                onChange={(e) => { this.handleDateTimeChange(e, 'Data') }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </MuiThemeProvider>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} key={'form_Presenza'} >
                                                <FormControl className={classes.formControlS}>
                                                    <FormLabel component="legend">Presenza*</FormLabel>
                                                    <RadioGroup aria-label='Presenza' name='Presenza' value={this.state.formValue['Presenza']} onChange={(e) => {
                                                        e.preventDefault()
                                                        this.onChangeInputCommon('Presenza', e.target.value)
                                                    }}>
                                                        {
                                                            this.props.modelProps.props['Presenza'].option.map((op) => {
                                                                return (
                                                                    <FormControlLabel key={'key_' + op.val} value={op.val} control={<Radio />} label={op.label} />
                                                                )
                                                            })
                                                        }
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} key={'form_Ore'}  >
                                                <FormControl className={classes.formControlS}>
                                                    <TextField
                                                        id="standard-basic"
                                                        label='Ore'
                                                        value={this.state.formValue['Ore']}
                                                        onChange={(e) => {
                                                            e.preventDefault()
                                                            this.onChangeInputNumCommon('Ore', e.target.value)
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            {this.props.role == 'euroalbek' &&
                                                <Grid item xs={12} key={'form_CostoOrario'}  >
                                                    <FormControl className={classes.formControlS}>
                                                        <TextField
                                                            id="standard-basic"
                                                            label='Costo Orario'
                                                            value={this.state.formValue['CostoOrario']}
                                                            onChange={(e) => {
                                                                e.preventDefault()
                                                                this.onChangeInputNumCommon('CostoOrario', e.target.value)
                                                            }}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                            }

                                            <Grid item xs={12} key={'form_Descrizione'}  >
                                                <FormControl className={classes.formControlM}>
                                                    <TextField
                                                        id="standard-basic"
                                                        label='Descrizione'
                                                        value={this.state.formValue['Descrizione']}
                                                        onChange={(e) => {
                                                            e.preventDefault()
                                                            this.onChangeInputCommon('Descrizione', e.target.value)
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>


                                            {this.props.role == 'euroalbek' &&
                                                <Grid item xs={12} key={'radio_Confermata'} >
                                                    <FormControl className={classes.formControlM}>

                                                        <FormControlLabel control={
                                                            <Checkbox
                                                                defaultChecked
                                                                checked={this.state.formValue['Confermata']}
                                                                onChange={(e) => {
                                                                    e.preventDefault()
                                                                    console.log('Checkbox', e.target.value)
                                                                    if (this.state.formValue['Confermata']) {
                                                                        this.onChangeInputCommon('Confermata', false)
                                                                    } else {
                                                                        this.onChangeInputCommon('Confermata', true)
                                                                    }

                                                                }}
                                                            />
                                                        } label="Confermata" />
                                                    </FormControl>
                                                </Grid>
                                            }
                                            <Grid item xs={12} >
                                                <Button
                                                    variant="contained"
                                                    // disabled={this.state.formValue.Dipendenti == null ||
                                                    //     this.state.formValue.Presenza == null ||
                                                    //     this.state.formValue.Data == null ||
                                                    //     this.state.formValue.Data == ""
                                                    //     ? true
                                                    //     : false
                                                    // }

                                                    disabled={this.state.unfilledRequiredFIeld}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        //最終更新者・日時を追加
                                                        var newFormValue = this.state.formValue;
                                                        newFormValue["LastModifiedBy"] = this.props.logininfo.userId;
                                                        newFormValue["LastModifiedAt"] = DateTool.returnItalianTime();


                                                        if (this.state.formValue.Ore == '') {
                                                            newFormValue["Ore"] = null
                                                        }
                                                        if (this.state.formValue.CostoOrario == '') {
                                                            newFormValue["CostoOrario"] = null
                                                        }


                                                        newFormValue["UserId"] = this.state.formValue.Dipendenti.UserId

                                                        this.setState({ formValue: newFormValue });

                                                        console.log('create newFormValue',newFormValue)

                                                        console.log('logininfo',this.props.logininfo)

                                                        this.props.submitCreate(
                                                            this.props.role == 'euroalbek' ? null : this.props.logininfo.userId,
                                                            this.props.firstdayofmonth,
                                                            this.props.page,
                                                            this.props.numData,
                                                            newFormValue,
                                                            this.props.logininfo.id)


                                                        this.handleModalClose();


                                                    }}>Aggiunta</Button>
                                            </Grid>
                                        </Grid >
                                    </form>
                                </Grid>
                            </Grid>



                        </div>
                    </Fade>
                </Modal >

            </div>

        );
    }
}


const mapStateToProps = (state) => {
    return {
        logininfo: state.auth.logininfo,
        role: state.auth.role

    }
}

const mapDispatchToProps = (dispatch) => {

    return {

        submitCreate: (userId, firstdayofmonth, page, numData, formValue, access_token) => {
            console.log('formValue', formValue)
            dispatch(PresenzeAction.apiPostOrPut(userId, firstdayofmonth, page, numData, formValue, access_token))
        },



    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(SimpleCrudModalCreate));